import state from '@/store/modules/auctions/defaultState';

const actions = {
  async getMyAcvActiveBuyingAuctions({
    dispatch,
  }) {
    const auctions = await dispatch('auctions/getAuctionList', {
      subscribeAuctions: true,
      apiMethod: 'getMyAcvActiveBuyingAuctions',
      moduleKey: 'MyAcvActive.MyAcvActiveBuying',
      numberOfLoaders: 3,
      page: 1,
    }, {
      root: true,
    });
    return auctions;
  },
};

export default {
  state,
  actions,
};
